import { Injectable } from '@angular/core';

export interface StatusConfig {
  class: string;
  icon: string;
  color: string;
  backgroundColor: string;
}

@Injectable({
  providedIn: 'root'
})
export class StatusService {
  private readonly statusConfigs: { [key: string]: StatusConfig } = {
    'Applied': {
      class: 'open',
      icon: 'schedule',
      color: 'rgba(137, 80, 252)',
      backgroundColor: 'rgba(137, 80, 252, 0.1)'
    },
    'Open': {
      class: 'open',
      icon: 'schedule',
      color: 'rgba(137, 80, 252)',
      backgroundColor: 'rgba(137, 80, 252, 0.1)'
    },
    'Under Review': {
      class: 'screening',
      icon: 'visibility',
      color: 'rgba(165, 42, 114)',
      backgroundColor: 'rgba(165, 42, 114, 0.1)'
    },
    'Screening': {
      class: 'screening',
      icon: 'visibility',
      color: 'rgba(165, 42, 114)',
      backgroundColor: 'rgba(165, 42, 114, 0.1)'
    },
    'Interview': {
      class: 'interview',
      icon: 'event',
      color: 'rgba(27, 197, 189)',
      backgroundColor: 'rgba(27, 197, 189, 0.1)'
    },
    'Rejected': {
      class: 'rejected',
      icon: 'cancel',
      color: 'rgba(246, 78, 96)',
      backgroundColor: 'rgba(246, 78, 96, 0.1)'
    },
    'Accepted': {
      class: 'accepted',
      icon: 'check_circle',
      color: 'rgba(28, 204, 11)',
      backgroundColor: 'rgba(28, 204, 11, 0.1)'
    },
    'Hired': {
      class: 'hired',
      icon: 'work',
      color: 'rgba(0, 95, 107)',
      backgroundColor: 'rgba(0, 95, 107, 0.1)'
    },
    'Shortlist': {
      class: 'shortlist',
      icon: 'bookmark',
      color: 'rgba(128, 128, 0)',
      backgroundColor: 'rgba(128, 128, 0, 0.1)'
    },
    'Offer': {
      class: 'offer',
      icon: 'handshake',
      color: 'rgba(82, 115, 255)',
      backgroundColor: 'rgba(82, 115, 255, 0.1)'
    }
  };

  private readonly defaultConfig: StatusConfig = {
    class: 'status-default',
    icon: 'help_outline',
    color: '#6b7280',
    backgroundColor: '#f3f4f6'
  };

  /**
   * Get the CSS class for a given status
   */
  getStatusClass(status: string): string {
    return this.statusConfigs[status]?.class || this.defaultConfig.class;
  }

  /**
   * Get the icon for a given status
   */
  getStatusIcon(status: string): string {
    return this.statusConfigs[status]?.icon || this.defaultConfig.icon;
  }

  /**
   * Get the color for a given status
   */
  getStatusColor(status: string): string {
    return this.statusConfigs[status]?.color || this.defaultConfig.color;
  }

  /**
   * Get the background color for a given status
   */
  getStatusBackgroundColor(status: string): string {
    return this.statusConfigs[status]?.backgroundColor || this.defaultConfig.backgroundColor;
  }

  /**
   * Get the complete status configuration for a given status
   */
  getStatusConfig(status: string): StatusConfig {
    return this.statusConfigs[status] || this.defaultConfig;
  }

  /**
   * Get all available status names
   */
  getAllStatuses(): string[] {
    return Object.keys(this.statusConfigs);
  }

  /**
   * Check if a status is valid/supported
   */
  isValidStatus(status: string): boolean {
    return status in this.statusConfigs;
  }
}